import React, { Component } from "react";

import ImageItem from "./components/image-item";
import { startCase } from "lodash";
import { Input } from "../inputs";
import { getProvider } from "../shared/data";

import "./image-picker.scss";
import { attributeUUID } from "../../../shared/attribute-uuid";

const imagePickerHeaderWhitelist = [attributeUUID.kosherCodes, attributeUUID.certificationCodes, attributeUUID.recycleCodes];

class ImagePicker extends Component {
    constructor(props) {
        super(props);
        this.state = {
            inputFilter: "",
            selectedValue: props.defaultValue || [],
            options: props.options || [],
            filteredOptions: props.options || [],
        };
    }

    componentDidMount() {
        this.loadOptions();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.defaultValue !== this.props.defaultValue) {
            this.setState({
                selectedValue: this.props.defaultValue || [],
            });
        }
    }

    loadOptions = async () => {
        const options = this.props.provider
            ? await getProvider(this.props.provider)
            : this.props.loadOptions
              ? await this.props.loadOptions()
              : this.props.options || [];

        // Catch for success or failure
        if (options.success || options.error) {
            return;
        }

        this.setState({
            options: options,
            filteredOptions: options,
        });
    };

    filterOptions = (value) => {
        const options = this.state.options;

        return value ? options.filter((o) => o.text.toLowerCase().includes(value.toLowerCase())) : options;
    };

    updateField = (name, value) => {
        this.setState({
            [name]: value,
            filteredOptions: this.filterOptions(value),
        });
    };

    onImageSelect = (selectedValue, isRemove) => {
        const oldSelectedValue = [...this.state.selectedValue];
        const newSelectedValue = isRemove
            ? oldSelectedValue.filter((v) => v.value !== selectedValue.value)
            : [...oldSelectedValue, { ...selectedValue }];

        this.setState({
            selectedValue: newSelectedValue,
        });
    };

    handleSave = () => {
        this.props.updateOnChange(this.props.name, this.state.selectedValue);
    };

    onKeyUp = (e) => {
        if (e.which === 27 || e.keyCode === 27) {
            this.setState({
                inputFilter: "",
                filteredOptions: this.filterOptions(""),
            });
        }
    };

    render() {
        const displayHeader = imagePickerHeaderWhitelist.some((uuid) => this.props.uuid === uuid);
        const selectedValue = this.state.selectedValue;
        const selectedIds = selectedValue.map((v) => v.value);
        const selectedImageItems = selectedValue.map((item) => {
            return (
                <ImageItem
                    key={`selected_${item.value}`}
                    provider={this.props.provider}
                    data={item}
                    updateOnChange={this.onImageSelect}
                    isActive={true}
                />
            );
        });
        const imageItems = this.state.filteredOptions.map((item) => {
            const isActive = selectedIds.includes(item.value);

            return (
                <ImageItem
                    key={`item_${item.value}`}
                    provider={this.props.provider}
                    data={item}
                    updateOnChange={this.onImageSelect}
                    isActive={isActive}
                />
            );
        });

        return (
            <div className="image-picker">
                {displayHeader && <h1 className="txt-center">{startCase(this.props.label)}</h1>}
                <fieldset>
                    <legend>Selected Images</legend>
                    <div className="selected-images">{selectedImageItems}</div>
                </fieldset>
                <Input
                    name="inputFilter"
                    value={this.state.inputFilter}
                    onKeyUp={this.onKeyUp}
                    updateOnChange={this.updateField}
                    label="Search Images"
                />
                <div className="image-list">{imageItems}</div>
                <div className="button-group">
                    <button
                        disabled={this.state.selectedValue.length === 0}
                        className="button -primary"
                        onClick={this.handleSave}
                    >
                        Save
                    </button>
                </div>
            </div>
        );
    }
}

export default ImagePicker;
